import { UserAction } from '../store/UsersContext';
import { UsersValidation } from '../utils/types';
export const FETCH_USERS_PENDING = 'FETCH_USERS_PENDING';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';
export const SET_VALIDATION_START = 'SET_VALIDATION_START';
export const SET_VALIDATION_COMPLETED = 'SET_VALIDATION_COMPLETED';

export interface IUserAction {
  type: string;
  data?: UsersValidation;
}

export const setValidationContext = async (dispatch: (args: UserAction) => void, data: UsersValidation) => {
  dispatch({
    type: SET_VALIDATION_START,
    data: data,
  });

  return null;
};
